import { render, staticRenderFns } from "./default.vue?vue&type=template&id=cccb7208&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=cccb7208&prod&lang=css"
import style1 from "./default.vue?vue&type=style&index=1&id=cccb7208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccb7208",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonHearder: require('/73app-view/components/common-hearder.vue').default,CommonService: require('/73app-view/components/common-service.vue').default,CommonFooter: require('/73app-view/components/common-footer.vue').default})
